import { useEffect } from 'react';
import { ANALYTICS } from '../constants';

export default function Analytics() {
  useEffect(() => {
    // Google Analytics 4
    if (ANALYTICS.gaId) {
      const s1 = document.createElement('script');
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS.gaId}`;
      document.head.appendChild(s1);

      const s2 = document.createElement('script');
      s2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${ANALYTICS.gaId}');
      `;
      document.head.appendChild(s2);
    }

    // Яндекс.Метрика
    if (ANALYTICS.ymId) {
      const ym = document.createElement('script');
      ym.type = 'text/javascript';
      ym.innerHTML = `
        (function(m,e,t,r,i,k,a){
            m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
        })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${ANALYTICS.ymId}', 'ym');

        ym(${ANALYTICS.ymId}, 'init', {
          ssr:true,
          webvisor:true,
          clickmap:true,
          ecommerce:"dataLayer",
          referrer: document.referrer,
          url: location.href,
          accurateTrackBounce:true,
          trackLinks:true
        });
      `;
      document.head.appendChild(ym);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${ANALYTICS.ymId}" style="position:absolute;left:-9999px;" alt="" /></div>`;
      document.body.appendChild(noscript);
    }
  }, []);

  return null;
}
